import { Button, Popconfirm, PopconfirmProps } from '@arco-design/web-react';
import React from 'react';

export function ButtonOperate({
  onOk,
  status,
  text,
  disabled,
  loading = false,
}: PopconfirmProps & {
  status: 'warning' | 'danger' | 'success' | 'default' | undefined;
  text: string;
  loading?: boolean;
}) {
  return (
    <Popconfirm title="确定操作?" onOk={onOk}>
      <Button type="secondary" status={status} size="small" disabled={disabled} loading={loading}>
        {text}
      </Button>
    </Popconfirm>
  );
}
